import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";
import { Icon } from "@/components/ui/icon"

type MobileEnrollmentActionBarProps = {
  visible: boolean;
  showActionRequired?: boolean;
  priceLabel?: string | null;
  priceSuffix?: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
  buttonDisabled?: boolean;
  hint?: string | null;
  buttonClassName?: string;
  buttonIcon?: string;
  /** Substitui o botão padrão (ex.: GameRegistrationButton). */
  action?: ReactNode;
};

export function MobileEnrollmentActionBar({
  visible,
  showActionRequired = true,
  priceLabel,
  priceSuffix,
  buttonLabel,
  onButtonClick,
  buttonDisabled,
  hint,
  buttonClassName,
  buttonIcon,
  action,
}: MobileEnrollmentActionBarProps) {
  if (!visible) return null;

  return (
    <div className="lg:hidden fixed bottom-[calc(4rem_+_env(safe-area-inset-bottom))] left-4 right-4 mb-3 z-[51] bg-card/95 backdrop-blur-lg border border-card-border rounded-xl shadow-md">
      <div className="px-4 py-3">
        <div className="flex flex-col gap-3">
          {showActionRequired ? (
            <div className="flex items-center justify-center gap-2">
              <span className="w-2 h-2 rounded-full bg-orange-500 animate-pulse" />
              <span className="text-orange-500 text-xs font-bold tracking-wider animate-pulse">
                Ação Necessária
              </span>
            </div>
          ) : null}
          {priceLabel ? (
            <p className="text-center leading-none">
              <span className="text-2xl font-black tabular-nums text-foreground">{priceLabel}</span>
              {priceSuffix ? (
                <span className="ml-1 text-sm font-semibold text-muted-foreground">{priceSuffix}</span>
              ) : null}
            </p>
          ) : null}
          {action ?? (
            <Button
              type="button"
              onClick={onButtonClick}
              disabled={buttonDisabled}
              className={cn("w-full h-12 text-base font-bold rounded-xl", buttonClassName)}
            >
              {buttonIcon ? (
                <Icon name={buttonIcon} />
              ) : null}
              {buttonLabel}
            </Button>
          )}
          {hint ? <p className="text-center text-muted-foreground text-sm">{hint}</p> : null}
        </div>
      </div>
    </div>
  );
}
